import Vue from 'vue'
import VueRouter from 'vue-router'
import VisitorClassificationsOverview from '@/vue/settings/application/visitorclassifications/VisitorClassificationsOverview.vue'
import SegmentEdit from '@/vue/settings/application/visitorclassifications/SegmentEdit.vue'
import CustomFieldsOverview from '@v/settings/application/custom-fields/CustomFieldsOverview'
import CustomFieldEdit from '@v/settings/application/custom-fields/CustomFieldEdit'
import CustomFieldRemove from '@v/settings/application/custom-fields/CustomFieldRemove'
import BriqDummyPage from '@v/components/BriqDummyPage.vue'
import FunnelSettingsWrapper from '@v/settings/application/funnel/FunnelSettingsWrapper.vue'
import ShopSettingsWrapper from '@v/settings/application/shop/ShopSettingsWrapper.vue'
import EmailSettingsWrapper from '@v/settings/application/emails/EmailSettingsWrapper.vue'
import BillingSettingsWrapper from '@v/settings/application/billing/BillingSettingsWrapper.vue'
import AdvancedSettingsWrapper from '@v/settings/application/advanced/AdvancedSettingsWrapper.vue'
import UpsertScheduleItemWrapper from '@v/schedule/UpsertScheduleItemWrapper.vue'
import inventoryRoutes from '@/vue/inventory/inventoryRoutes.js'
import planboardRoutes from '@/vue/planboard/planboardRoutes.js'
import { bookingRoutes } from '@/vue/bookings/bookingRoutes.js'

Vue.use(VueRouter)

// todo fix broken css for lazy loading, but it's not easy. See:
// https://stackoverflow.com/questions/67059234/lazy-load-vue-components-in-a-laravel-application-not-loading

const {
  userIsAdvanced,
  envFeatureFlags,
  userCanViewAutitTrail,
  businessUnitKey,
  businessUnitDomain,
  enabledFeatures,
  priceIncludesTaxDefaultValue,
} = window.briqState || {}

export const routes = [
  {
    path: '/spa/settings/application/funnel',
    component: FunnelSettingsWrapper,
    name: 'Funnel',
    props: {
      userIsAdvanced,
      enableMultiLanguage: envFeatureFlags?.['enable-multilanguage'],
      canViewAuditTrail: userCanViewAutitTrail,
      enableCustomDomain: envFeatureFlags?.['enable-custom-domain'],
    },
  },
  {
    path: '/spa/settings/application/shop',
    component: ShopSettingsWrapper,
    name: 'Shop',
    props: {
      enableMultiLanguage: envFeatureFlags?.['enable-multilanguage'],
      activityFiltersUseSlug: envFeatureFlags?.['activity-filters-use-slug'],
    },
  },
  {
    path: '/spa/settings/application/email',
    component: EmailSettingsWrapper,
    name: 'Email',
    props: {
      enableMultiLanguage: envFeatureFlags?.['enable-multilanguage'],
    },
  },
  {
    path: '/spa/settings/application/billing',
    component: BillingSettingsWrapper,
    name: 'Billing',
    props: {
      userIsAdvanced,
      businessUnitKey,
    },
  },
  {
    path: '/settings/application/visitorclassifications',
    component: VisitorClassificationsOverview,
    name: 'VisitorClassificationsOverview',
  },
  {
    path: '/settings/application/visitorclassifications/:classificationCode/segment/new',
    component: SegmentEdit,
    name: 'SegmentNew',
    props: true,
  },
  {
    path:
      '/settings/application/visitorclassifications/:classificationCode/segment/:segmentCode/edit',
    component: SegmentEdit,
    name: 'SegmentEdit',
    props: true,
  },
  {
    path: '/settings/application/custom-fields',
    component: CustomFieldsOverview,
    name: 'CustomFieldsOverview',
  },
  {
    path: '/settings/application/custom-fields/add',
    component: CustomFieldEdit,
    name: 'CustomFieldNew',
    props: true,
  },
  {
    path: '/settings/application/custom-fields/:customFieldKey/edit',
    component: CustomFieldEdit,
    name: 'CustomFieldEdit',
    props: true,
  },
  {
    path: '/settings/application/custom-fields/:customFieldKey/delete',
    component: CustomFieldRemove,
    name: 'CustomFieldRemove',
    props: true,
  },
  ...bookingRoutes,
  ...inventoryRoutes,
  ...planboardRoutes,
  // todo 404 wildcard
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.afterEach((to, _from) => {
  Vue.nextTick(() => {
    if (to.meta.title)
      document.title = `${to.meta.title} - ${window.businessUnitName} - BRIQ Bookings`
  })
})

export default router
